import mapperIcons from '../../../../schema/mapperIcons';
import { BiCode } from '../../../../../../components/react-icons/main';

const formatMappers = (mappers = [], opts = {}) => {
  const type = opts.type || 'response';
  const dataTypeDirection = type === 'response' ? 1 : -1;
  return mappers
    .map((n) => ({
      ...n,
      icon: mapperIcons[n.type] || BiCode,
      isTrigger: opts?.isTrigger === true
    }))
    .sort((a, b) => a?.sequence - b?.sequence)
    .sort((a) => (a.type === 'dataType' ? dataTypeDirection : 0));
};

export default formatMappers;
